// AGT (aynı gün teslimat) widget'ı sayfada gerçekten çalışıp render olana kadar
// (örn. tema app embed'i kapalıysa) teslimat adımını kilitlemeyelim - script hiç
// devreye girmezse bu bayrak false kalır ve sepete ekleme engellenmez.
let deliveryWidgetSeen = false;

function isDeliverySelectionReady() {
  const root = document.getElementById("local-delivery-app-root");
  if (!root) return true;
  if (!deliveryWidgetSeen) return true;
  return !!(
    root.querySelector(".ld-date-card.active") ||
    root.querySelector(".ld-status-card--cargo")
  );
}

function updateBoxBuilderState() {
  const step1Items = document.querySelector("#step1-items");
  const step2Items = document.querySelector("#step2-items");
  const stepWrap = document.querySelector(".step-wrap.step-second");
  const selectCartButton = document.querySelector("#select-cart");
  const addToCart = document.querySelector("#add-to-cart");
  const addAndNew = document.querySelector("#add-and-new");
  const addAndViewFlowers = document.querySelector("#add-and-view-flowers");

  const hasBox = step1Items && step1Items.children.length > 0;
  const hasItems = step2Items && step2Items.children.length > 0;

  // 1. Kutu Seçildiyse Step 2'nin Kilit Ekranını Kaldır
  if (stepWrap) {
    if (hasBox) {
      stepWrap.classList.add("step-1-done");
    } else {
      stepWrap.classList.remove("step-1-done");
    }
  }

  // 2. Butonları Aktifleştir/Kilitler (Kutu + En az 1 ürün seçili olmalı)
  const isDisabled = !hasBox || !hasItems;
  const deliveryReady = isDeliverySelectionReady();
  if (selectCartButton) selectCartButton.disabled = isDisabled;
  if (addToCart) addToCart.disabled = isDisabled || !deliveryReady;
  if (addAndNew) addAndNew.disabled = isDisabled || !deliveryReady;
  if (addAndViewFlowers) addAndViewFlowers.disabled = isDisabled || !deliveryReady;

  // 3. Görsel Adım Göstergesini (Stepper) Güncelle
  const stepperItem1 = document.querySelector(".stepper-item.step-1");
  const stepperItem2 = document.querySelector(".stepper-item.step-2");
  const stepperItem3 = document.querySelector(".stepper-item.step-3");

  if (stepperItem1) {
    if (hasBox) {
      stepperItem1.classList.add("completed");
      stepperItem1.classList.remove("active");
    } else {
      stepperItem1.classList.add("active");
      stepperItem1.classList.remove("completed");
    }
  }

  if (stepperItem2) {
    if (hasBox) {
      stepperItem2.classList.add("active");
      stepperItem2.classList.remove("completed", "locked");
    } else {
      stepperItem2.classList.add("locked");
      stepperItem2.classList.remove("active", "completed");
    }
  }

  if (stepperItem3) {
    stepperItem3.classList.add("locked");
    stepperItem3.classList.remove("active", "completed");
  }
}

// Olay tetikleyicileri
document.addEventListener("click", function () {
  setTimeout(updateBoxBuilderState, 300);
});

// AGT teslimat widget'ı (#local-delivery-app-root) her yeniden render olduğunda
// (konum/tarih seçimi değiştiğinde) sepete ekle butonlarının kilidini güncelle
document.addEventListener("DOMContentLoaded", function () {
  const deliveryRootEl = document.getElementById("local-delivery-app-root");
  if (!deliveryRootEl) return;

  const deliveryObserver = new MutationObserver(function () {
    deliveryWidgetSeen = true;
    updateBoxBuilderState();
  });
  deliveryObserver.observe(deliveryRootEl, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function () {
  updateBoxBuilderState();
});

// .right-side-opener öğesine tıklama (veya dokunma) durumu
const rightSideOpener = document.querySelector(".right-side-opener");
if (rightSideOpener) {
  rightSideOpener.addEventListener("click", function () {
    // .kendi-kutunu-yap-wrapper .right öğesine 'mobile open' sınıflarını ekle
    const rightWrapper = document.querySelector(
      ".kendi-kutunu-yap-wrapper .right"
    );
    if (rightWrapper) {
      rightWrapper.classList.add("open");
    }
  });
}

// #kart-alani veya #close-side öğelerine tıklama durumunda
document
  .querySelectorAll("#kart-alani, #close-side, .close-side")
  .forEach((element) => {
    element.addEventListener("click", function () {
      // .kendi-kutunu-yap-wrapper .right öğesinden 'mobile open' sınıflarını kaldır
      const rightWrapper = document.querySelector(
        ".kendi-kutunu-yap-wrapper .right"
      );
      if (rightWrapper) {
        rightWrapper.classList.remove("open");
      }
    });
  });
// .kendi-kutunu-yap-wrapper .right öğesini seç
const rightWrapper = document.querySelector(".kendi-kutunu-yap-wrapper .right");

// MutationObserver ile değişiklikleri izle
const observer = new MutationObserver(function (mutationsList) {
  updateBoxBuilderState();
});

// İzlenecek elementler (step1-items, step2-items, step3-items)
const steps = ["#step1-items", "#step2-items", "#step3-items"];

// Observer için her bir step öğesini izle
steps.forEach((stepId) => {
  const stepElement = document.querySelector(stepId);
  if (stepElement) {
    observer.observe(stepElement, { childList: true, subtree: true });
  }
});
document.addEventListener("click", function () {
  setTimeout(function () {
    let total = 0; // Her tıklamada total sıfırlanır

    // .selected-items içindeki tüm .product-each-price spanlarını seç
    const priceElements = document.querySelectorAll(
      ".selected-items .product-each-price"
    );

    priceElements.forEach((span) => {
      // Span içindeki sayıyı al, " TL" kısmını kaldır, ve sayıya çevir
      const priceText = span.textContent.replace(" TL", "").trim();
      const price = parseFloat(priceText);

      // Eğer price geçerli bir sayı ise total'e ekle
      if (!isNaN(price)) {
        total += price;
      }
    });

    // Toplamı #total-price-value-original id'li span içine yazdır
    const totalOriginalEl = document.getElementById("total-price-value-original");
    if (totalOriginalEl) {
      totalOriginalEl.textContent = total.toFixed(2) + " TL";
    }
  }, 500); // 500 milisaniye gecikme
});
document.addEventListener("DOMContentLoaded", function () {
  // Delegated: İncele butonuna tıklanınca detailed-view'e active sınıfı ekle
  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest(".model-2[open-box], .light-box-oprn-all, [open-box]");
    if (!openBtn) return;
    
    const item = openBtn.closest(".product-list-item, .box-card");
    if (!item) return;
    
    const detailedView = item.querySelector(".detailed-view");
    if (!detailedView) return;
    
    detailedView.classList.add("active");
    document.body.classList.add("detailed-view-active");

    // İlk gösterilecek resim ayarı
    const productImageDiv = detailedView.querySelector(".product-image");
    const variantSelector = detailedView.querySelector(".variant-selector");
    if (variantSelector && productImageDiv) {
      const initialVariantId = variantSelector.value;
      updateProductImage(productImageDiv, initialVariantId);
    }
  });

  // Delegated: Lightbox'taki küçük görsele tıklanınca ana görseli değiştir
  document.addEventListener("click", function (e) {
    const thumb = e.target.closest(".lightbox-thumb");
    if (!thumb) return;

    const gallery = thumb.closest(".product-image");
    if (!gallery) return;

    const mainImg = gallery.querySelector(".lightbox-main-image img");
    const fullSrc = thumb.getAttribute("data-full");
    if (mainImg && fullSrc) {
      // srcset varsa src'yi ezer, temizlemeden görsel değişmiyor.
      mainImg.removeAttribute("srcset");
      mainImg.src = fullSrc;
    }

    gallery.querySelectorAll(".lightbox-thumb").forEach((t) => t.classList.remove("active"));
    thumb.classList.add("active");
  });

  // Delegated: Variant seçici değiştiğinde imajı güncelle
  document.addEventListener("change", function (e) {
    const selector = e.target.closest(".variant-selector");
    if (!selector) return;
    
    const dv = selector.closest(".detailed-view");
    if (!dv) return;
    
    const productImageDiv = dv.querySelector(".product-image");
    if (!productImageDiv) return;
    
    const selectedVariantId = selector.value;
    updateProductImage(productImageDiv, selectedVariantId);
  });

  // Delegated: Kişiselleştirme metni girilince ilgili Ekle butonunu etkinleştir/devre dışı bırak
  document.addEventListener("input", function (e) {
    const input = e.target.closest(".custom-text");
    if (!input) return;
    
    const handle = input.getAttribute("data-product-handle");
    if (!handle) return;
    
    const scope = input.closest(".detailed-view, .details, .light-box-details");
    if (!scope) return;
    
    const button = scope.querySelector(`.ekle-ve-kapa[data-handle="${handle}"]`);
    if (!button) return;
    
    const bosMessage = scope.querySelector(".bos-message");
    
    if (input.value.trim() !== "") {
      button.disabled = false;
      if (bosMessage) {
        bosMessage.style.display = "none";
      }
    } else {
      button.disabled = true;
      if (bosMessage) {
        bosMessage.style.display = "block";
      }
    }
  });

  // Kişiselleştirme input'u olmayan butonları enabled yap (sayfa yüklendiğinde ve yeni ürünler eklendiğinde)
  function enableButtonsWithoutCustomInputs() {
    document.querySelectorAll(".ekle-ve-kapa, .select-product-step-1, .select-product-step-2").forEach((button) => {
      const handle = button.getAttribute("data-handle");
      if (!handle) return;
      
      // Butonun bulunduğu container'ı bul - önce product-list-item, sonra details
      const productItem = button.closest(".product-list-item");
      const container = productItem || button.closest(".detailed-view, .details");
      if (!container) return;
      
      // Bu ürün için kişiselleştirme input'u var mı kontrol et
      // Hem lightbox içinde hem de direkt butonlar için kontrol et
      const hasCustomTextInput = container.querySelector(`input.custom-text[data-product-handle="${handle}"], input#${handle}-urun-uzerindeki-yazi, input#${handle}-urun-uzerindeki-harf`);
      
      // Eğer kişiselleştirme input'u yoksa VE buton disabled ise, enabled yap
      if (!hasCustomTextInput && button.disabled) {
        button.disabled = false;
      }
    });
  }

  // Sayfa yüklendiğinde çalıştır
  setTimeout(enableButtonsWithoutCustomInputs, 100);

  // Yeni ürünler eklendiğinde de çalıştır (MutationObserver ile)
  const productsObserver = new MutationObserver(function(mutations) {
    // Sadece gerçekten yeni ürün eklendiğinde çalıştır (debounce)
    clearTimeout(productsObserver.timeout);
    productsObserver.timeout = setTimeout(enableButtonsWithoutCustomInputs, 100);
  });

  // Products list area'ları izle
  document.querySelectorAll(".products-list-area, .hediye-product-list").forEach((area) => {
    productsObserver.observe(area, { childList: true, subtree: true });
  });

  // Delegated: Ekle ve kapat butonu tıklanınca lightbox kapansın
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".ekle-ve-kapa");
    if (!btn) return;
    
    if (btn.disabled) {
      e.preventDefault();
      return;
    }

    const detailedView = btn.closest(".detailed-view");
    if (detailedView) {
      detailedView.classList.remove("active");
      document.body.classList.remove("detailed-view-active");
    }
  });

  // Seçilen varyanta göre ürün görselini güncelle
  function updateProductImage(productImageDiv, variantId) {
    if (!productImageDiv || !variantId) return;
    
    const item = productImageDiv.closest(".product-list-item");
    if (!item) return;
    
    const variantSelector = item.querySelector(".variant-selector");
    if (!variantSelector) return;
    
    const productHandle = variantSelector.getAttribute("data-handle");
    if (!productHandle) return;
    
    fetch(window.location.origin + `/products/${productHandle}.js`)
      .then((response) => {
        if (!response.ok) throw new Error("Ürün verisi alınamadı.");
        return response.json();
      })
      .then((data) => {
        const selectedVariant = data.variants.find(
          (variant) => variant.id == variantId
        );
        if (!selectedVariant || !selectedVariant.featured_image) return;

        // Galeri varsa innerHTML'i ezmeyelim, yoksa küçük görseller silinir.
        const mainImg = productImageDiv.querySelector(".lightbox-main-image img");
        if (mainImg) {
          mainImg.removeAttribute("srcset");
          mainImg.src = selectedVariant.featured_image.src;
          productImageDiv
            .querySelectorAll(".lightbox-thumb")
            .forEach((t) => t.classList.remove("active"));
        } else {
          productImageDiv.innerHTML = `<img src="${selectedVariant.featured_image.src}" alt="${data.title}" class="variant-image">`;
        }
      })
      .catch((error) => {
        console.error("Varyant görseli yüklenirken hata oluştu:", error);
      });
  }

  // Delegated: Lightbox kapatma butonu
  document.addEventListener("click", function (e) {
    const closeBtn = e.target.closest(".detailed-view .close");
    if (!closeBtn) return;
    
    const detailedView = closeBtn.closest(".detailed-view");
    if (detailedView) {
      detailedView.classList.remove("active");
      document.body.classList.remove("detailed-view-active");
    }
  });

  // Delegated: Lightbox dışındaki boşluğa (backdrop) tıklanınca lightbox kapansın
  document.addEventListener("click", function (e) {
    if (e.target.matches(".detailed-view")) {
      e.target.classList.remove("active");
      document.body.classList.remove("detailed-view-active");
    }
  });

  // Delegated: Ürün görseline tıklanınca resmi büyük boyutta aç (zoom)
  document.addEventListener("click", function (e) {
    const clickedImg = e.target.closest(".detailed-view .product-image img");
    if (!clickedImg) return;
    // Küçük görseller ana görseli değiştirmek için; onlarda zoom açılmasın.
    if (clickedImg.closest(".lightbox-thumbs")) return;
    
    // Büyük resim overlay oluştur
    const imageOverlay = document.createElement("div");
    imageOverlay.className = "product-image-zoom-overlay";
    imageOverlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.95);
      z-index: 11000;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: zoom-out;
      animation: fadeInZoom 0.2s ease-out;
    `;
    
    // Animasyon CSS ekle
    if (!document.getElementById("zoom-animation-style")) {
      const style = document.createElement("style");
      style.id = "zoom-animation-style";
      style.textContent = `
        @keyframes fadeInZoom {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `;
      document.head.appendChild(style);
    }
    
    const zoomImg = document.createElement("img");
    zoomImg.src = clickedImg.src;
    zoomImg.style.cssText = `
      max-width: 95%;
      max-height: 85%;
      object-fit: contain;
      border-radius: 12px;
      box-shadow: 0 10px 30px rgba(0,0,0,0.6);
      transform: scale(0.95);
      animation: scaleUpZoom 0.2s ease-out forwards;
    `;
    
    // Zoom animasyon CSS ekle
    if (!document.getElementById("zoom-scale-animation-style")) {
      const style = document.createElement("style");
      style.id = "zoom-scale-animation-style";
      style.textContent = `
        @keyframes scaleUpZoom {
          to { transform: scale(1); }
        }
      `;
      document.head.appendChild(style);
    }
    
    const closeText = document.createElement("div");
    closeText.textContent = "Kapatmak için dokunun";
    closeText.style.cssText = `
      margin-top: 16px;
      color: #ffffff;
      font-size: 13px;
      opacity: 0.7;
      font-family: sans-serif;
      letter-spacing: 0.5px;
      background: rgba(255,255,255,0.15);
      padding: 6px 16px;
      border-radius: 20px;
    `;
    
    imageOverlay.appendChild(zoomImg);
    imageOverlay.appendChild(closeText);
    document.body.appendChild(imageOverlay);
    
    // Tıklanınca kapat
    imageOverlay.addEventListener("click", function () {
      imageOverlay.remove();
    });
  });
});


